import type { ReportGroup } from '../types';
import { inspections } from './inspections';
import { items } from './items';
import { operations } from './operations';
import { overview } from './overview';
import { products } from './products';
import { rate } from './rate';
import { reasons } from './reasons';
import { revenue } from './revenue';
import { shopNow } from './shopNow';

export const returns = {
  key: 'returns',
  label: 'Returns',
  isEnabled: ({ isReturnsEnabled }) => isReturnsEnabled,
  filters: {
    claimItems: { claimTypes: ['Return'] },
    claims: { claimTypes: ['Return'] },
  },
  reports: [
    overview,
    rate,
    products,
    reasons,
    items,
    revenue,
    inspections,
    operations,
    shopNow,
  ],
} as const satisfies ReportGroup;
